<template>
    <ProductTop page="Artificial-Insemination" />
    <ProductList page="Artificial-Insemination" :nums="4" />
</template>

<script>
import ProductTop from '@/components/ProductTop.vue';
import ProductList from '@/components/ProductList.vue';
export default {
    // eslint-disable-next-line
    name: 'ArtificialInsemination',
    components: {
        ProductTop,
        ProductList
    }
}
</script>
